// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.joinUsParentButtonWeb.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

button.athelete-rookie-buy.AthleteJoinButton.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

button.athelete-elite-buy.AthleteJoinButton.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

button.athelete-pro-buy.AthleteJoinButton.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

button.parent-buy-btn.disable-hover.button.button-ios.button-default.button-default-ios:hover {
  opacity: 0.7 !important;
}

button.mbl-athelete-rookie-buy.disable-hover.button.button-ios.button-default.button-default-ios:hover {
  opacity: 0.7 !important;
}

button.mbl-athelete-elite-buy.disable-hover.button.button-ios.button-default.button-default-ios:hover {
  opacity: 0.7 !important;
}

button.mbl-athelete-pro-buy.disable-hover.button.button-ios.button-default.button-default-ios:hover {
  opacity: 0.7 !important;
}

button.parent-buy-btn.button.button-md.button-default.button-default-md:hover {
  opacity: 0.9 !important;
}

.e-grid.e-default.e-verticallines .e-headercell .e-headertext {
  font-size: 18px;
}

.ion-md-close {
  font-size: 24px !important;
  position: relative;
  top: 12px;
  color: #ffffff;
}

.closeButtonColorActive {
  color: #f4f7fc !important;
}

.closeButtonColorExpired {
  color: lightgray !important;
}

.alertMessage {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  top: 0px;
  padding: 0px;
}

p.alertText {
  text-align: center !important;
  font-size: 1.6rem;
  width: 100%;
}

ion-icon.iconCloseAlert {
  padding-right: 10px;
  cursor: pointer;
  top: 0px;
  -webkit-margin-before: 0.5em;
  -webkit-margin-after: 0em;
}

.e-grid.e-gridhover tr[role=row]:not(.e-editedrow):hover .e-rowcell:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell) {
  background-color: #6C6D71;
  color: white !important;
}

.e-grid .e-rowcell:hover {
  color: white !important;
}

.col {
  border-right: 3px solid #4F524D;
  font-size: 11px;
  height: 75px;
}

.col-border {
  border-bottom: 3px solid #4F524D;
}

ion-navbar .col {
  border-bottom: 0px;
  border-right: 0px;
  font-size: 11px;
  height: 56px;
  background: black !important;
}

.e-grid .e-rowcell {
  background-color: #6C6D71;
  color: white !important;
  border-color: #4F524D;
}

.e-grid .e-rowcell:hover {
  color: white !important;
  background-color: #6C6D71;
}

.ion-md-close {
  font-size: 24px !important;
  position: relative;
  top: 12px;
  color: #ffffff;
}

.e-grid {
  border-color: #4F524D;
}

.e-grid .e-gridheader {
  border-bottom-color: #4F524D;
  border-top-color: #4F524D;
}

.footer {
  text-align: center;
  font-size: 11px;
  font-style: italic;
  color: white;
  background: #BE1E2D;
}

.e-grid .e-headercell {
  background-color: #C01E2D;
  color: white;
}

.large-font {
  color: #ffffff;
  font-weight: 500;
  font-size: 20px !important;
  position: relative;
  top: 6px;
}

.subscription {
  height: 120px !important;
}

.subscription.subscriptionChild {
  height: 80px !important;
}

.athelete-rookie-buy {
  width: 120px;
  background-color: #00c09a !important;
}

.athelete-elite-buy {
  width: 120px;
  background-color: #0099e1 !important;
}

.athelete-pro-buy {
  width: 120px;
  background-color: #f93354 !important;
}

.parent-buy-btn {
  background: #f93354 !important;
  width: 100%;
  height: 43px !important;
  float: right;
  margin-right: 0 !important;
  color: white;
  font-size: 14px;
}

.featuregrid-left-margin {
  border-left: 1px solid #4F524D;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  border: 0px;
  height: 75px;
}

.featuregrid-left-margin-mobile {
  border-left: 1px solid #4F524D;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  border: 0px;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.featuregrid-right-margin {
  border-right: 3px solid #4F524D;
}

.featuregrid-top-margin {
  border-top: 1px solid #4F524D;
}

.gridBackground {
  background: #6C6D71;
}

.featuregrid-detail-content {
  color: #ffffff;
  font-size: 13px;
  font-weight: 400;
  top: 3px;
  position: relative;
}

.feature-grid-smallcontent {
  color: #ffffff;
  font-weight: 400;
  font-size: 11px;
}

.feature-grid-largecontent {
  font-size: 36px;
  text-align: center;
  color: #ffffff;
  font-weight: 500;
}

.feature-grid-header-content {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 500;
}

.down-arrow {
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  content: " ";
  position: absolute;
  bottom: 46px;
  left: 42%;
}

.down-arrow-rookie {
  border-top: 15px solid #00c09a;
}

.down-arrow-elite {
  border-top: 15px solid #0099e1;
}

.down-arrow-pro {
  border-top: 15px solid #f93354;
}

.onetime-activation-content {
  font-size: 12px;
  color: #ffffff;
  font-weight: 400;
}

.parent-child-grid-header {
  font-size: 14px;
  color: #121A3E;
  font-weight: 500;
  padding-left: 14px;
}

.parent-child-grid-content {
  font-size: 16px;
  color: #31384C;
  font-weight: 400;
  position: relative;
  top: 12px;
  padding-left: 14px;
}

.parent-child-header-content {
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
}

.grid-col {
  border: none !important;
  background: #F7F7F7;
}

.left-content {
  margin-left: 14px;
}

.mbl-centered-content {
  padding-left: 10px;
  position: relative;
  color: #ffffff;
}

.mbl-rookie-circle {
  padding-left: 10px;
  color: #00c09a;
  font-size: 24px !important;
}

.mbl-elite-circle {
  padding-left: 10px;
  color: #0099e1;
  font-size: 24px !important;
}

.mbl-pro-circle {
  padding-left: 10px;
  color: #f93354;
  font-size: 24px !important;
}

.mbl-subscription {
  padding-left: 10px;
  color: #ffffff;
}

.mbl-large-font {
  padding-right: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  float: right;
}

.mbl-onetime-activation {
  position: relative;
  top: 5px;
  left: 10px;
  color: #ffffff;
}

.mbl-athelete-rookie-buy {
  background: #00c09a !important;
  top: 12px;
  position: relative !important;
  left: 8px;
  height: 30px !important;
}

.mbl-athelete-elite-buy {
  background: #0099e1 !important;
  top: 12px;
  position: relative !important;
  left: 8px;
  height: 30px !important;
}

.mbl-athelete-pro-buy {
  background: #f93354 !important;
  top: 12px;
  position: relative !important;
  left: 8px;
  height: 30px !important;
}

.mbl-grid-col {
  background: transparent;
  border: none;
  height: 30px;
  font-size: 16px;
  position: relative;
  bottom: 10px;
  color: white;
}

.mbl-parent-grid-height {
  height: 56px !important;
}

.mbl-parent-childname-content {
  position: relative;
  top: 15px;
  color: #ffffff;
  font-weight: 400;
  left: 10px;
}

td.e-summarycell {
  background: #C01E2D !important;
  height: 50px !important;
  color: #ffffff !important;
}

.toolbar-background-md {
  background-color: black !important;
}

.profilemenu {
  float: right;
  margin-right: 15px;
  cursor: pointer;
  height: 40px;
}

.control-section {
  background-color: white !important;
  width: 100% !important;
}

.e-grid.e-default.e-verticallines .e-headercell,
.e-grid.e-default.e-verticallines .e-detailheadercell {
  border-width: 0 0 0 5px;
  border-color: #4f524d;
}

.e-grid.e-verticallines .e-rowcell,
.e-grid.e-verticallines .e-filterbarcell {
  border-width: 0px 0 0 5px;
  border-color: #4f524d;
}

.addathletebutton {
  background: none !important;
  border-right: none !important;
}

ion-col.featuregrid-left-margin.mobileBorder.col {
  border: 0px;
  padding-top: 10px !important;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
}

table.e-table {
  background-color: unset !important;
}

.e-gridheader.e-control.e-droppable {
  background-color: unset !important;
}

.e-gridfooter {
  background-color: unset !important;
}

td.e-summarycell {
  border-style: none !important;
}

ion-col.featuregrid-left-margin.mobileHighlightColumn.col {
  border-right: 0px;
  border-left: 0px;
  border-bottom: 2px solid #4F524D;
  border-top: 2px solid #4F524D;
  background: rgb(145, 147, 149);
}

ion-grid.setBoxShadow.grid {
  padding: 0px 5px !important;
}

.transaction-modal .modal-wrapper {
  box-shadow: 0 28px 48px rgba(0, 0, 0, 0);
  height: 250px;
}
.transaction-modal .modal-wrapper .scroll-content {
  overflow: hidden;
}

button.parent-buy-btn.button.button-md.button-default.button-default-md {
  margin-top: 4px !important;
  margin-right: 4px !important;
}

span.feature-grid-smallcontent.title {
  text-align: center;
  font-size: 15px;
}

ion-row.ActivationMessageMobile.row {
  margin-bottom: 20px;
  color: #ffffff;
}

ion-row.HeaderMobile.row {
  color: #ffffff;
}

span.ActivateMessaheSizeMobile {
  font-size: 12px;
}

ion-col.featuregrid-left-margin.PackageTitle {
  height: 50px;
  border: 0px;
  padding: 0 5px;
  background: #C01E2D;
}

ion-row.PackageDescriptionMobile.row {
  height: 35px;
}

ion-icon.mbl-rookie-circle.closeMobile.icon.icon-md.ion-md-close {
  top: 5px !important;
}

ion-icon.mbl-elite-circle.closeMobile.icon.icon-md.ion-md-close {
  top: 5px !important;
}

ion-icon.mbl-pro-circle.closeMobile.icon.icon-md.ion-md-close {
  top: 5px !important;
}

#ButtonHide {
  top: 5px;
}

#packageList input.e-input,
#packageList .e-input-group input.e-input,
#packageList .e-input-group.e-control-wrapper input.e-input {
  color: rgba(255, 255, 255, 0.87);
}
#packageList span.e-input-group.e-control-wrapper.e-ddl.e-control.e-keyboard {
  border: none;
}

app-home .e-grid.e-default.e-verticallines .e-headercell,
app-home .e-grid.e-verticallines .e-rowcell {
  border-width: 0 0 2px 3px;
}

button.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {
  background-color: #C01E2D !important;
  width: 20%;
}

ion-col.featuregrid-left-margin.GridDescription.col {
  text-align: center;
}

ion-col.featuregrid-left-margin.col-border.setPadding.col {
  padding: 9px;
}

ion-col.col-border.setPadding.col {
  padding: 9px;
}

@media only screen and (min-width: 1295px) {
  ion-col.col-border.FeaturePackageTitle.col {
    padding-top: 12px;
  }
  ion-col.featuregrid-left-margin.col-border.setPadding.col {
    padding: 10px;
  }
  ion-col.col-border.setPadding.col {
    padding: 10px;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  ion-icon.iconCloseAlert {
    font-size: 2.7rem !important;
    padding-right: 10px;
    cursor: pointer;
    top: 0px;
    -webkit-margin-before: 0.5em;
    -webkit-margin-after: 0em;
  }
}
@media only screen and (max-width: 768px) and (min-width: 556px) {
  app-home .feature-grid-header-content {
    font-size: 14px;
  }
  span.e-headertext {
    font-size: 14px !important;
  }
  strong.large-font.web {
    font-size: 14px !important;
  }
  app-home .featuregrid-detail-content {
    font-size: 10px;
  }
  ion-icon.icon.icon-md.ion-md-close {
    font-size: 20px !important;
  }
  span.onetime-activation-content.web {
    font-size: 10px;
  }
  button.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {
    min-width: 25% !important;
  }
  button.athelete-rookie-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {
    width: 75%;
  }
  button.athelete-elite-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {
    width: 75%;
  }
  button.athelete-pro-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {
    width: 75%;
  }
}
@media only screen and (max-width: 556px) {
  app-home .feature-grid-header-content {
    font-size: 11px;
  }
  span.e-headertext {
    font-size: 11px !important;
  }
  button.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {
    min-width: 35% !important;
  }
  strong.large-font.web {
    font-size: 11px !important;
  }
  app-home .featuregrid-detail-content {
    font-size: 9px;
  }
  ion-icon.icon.icon-md.ion-md-close {
    font-size: 16px !important;
    top: 8px;
  }
  span.onetime-activation-content.web {
    font-size: 8px;
  }
  button.athelete-rookie-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {
    width: 50%;
    font-size: 5px;
    height: 20px;
  }
  button.athelete-elite-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {
    width: 50%;
    font-size: 5px;
    height: 20px;
  }
  button.athelete-pro-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {
    width: 50%;
    font-size: 5px;
    height: 20px;
  }
  ion-icon.iconCloseAlert {
    font-size: 2.5rem !important;
    padding-right: 10px;
    cursor: pointer;
    top: 0px;
    -webkit-margin-before: 0.5em;
    -webkit-margin-after: 0em;
  }
}
@media only screen and (max-width: 450px) {
  .subscription.subscriptionChild {
    height: 120px !important;
  }
  button.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {
    min-width: 40% !important;
  }
}
td.e-rowcell.e-selectionbackground.e-active[aria-selected=true] {
  background-color: #919395 !important;
  color: white !important;
}

.col-md-12.checkboxColumn {
  text-align: center;
  width: 100%;
  font-size: 12px !important;
  margin-bottom: 5px;
}

p.waiverWarningText {
  color: white;
}

.checkboxLabel {
  margin-left: 5px;
}

#waiverCheckbox.e-checkbox-wrapper .e-frame,
#waiverCheckbox.e-css.e-checkbox-wrapper .e-frame {
  background-color: #000 !important;
  border: 1px solid !important;
  border-color: #fff !important;
}

#waiverCheckbox.e-checkbox-wrapper .e-checkbox:focus + .e-frame.e-check,
#waiverCheckbox.e-css.e-checkbox-wrapper .e-checkbox:focus + .e-frame.e-check {
  background-color: #e3165b !important;
  border-color: transparent;
  color: #fff;
}

.addOnCheckBox {
  font-size: 12px;
  color: #ffffff;
  font-weight: 400;
  display: inline-block;
}

.packageRow1 {
  background-color: #6C6D71;
  /*background: #aad190;*/
}

.packageRow2 {
  /*background: #70ad48;*/
  background-color: #919395;
}

.button-outline-ios {
  border-color: white !important;
  color: white !important;
}

.comingSoonText {
  position: absolute;
  transform: translate(20px, 130px);
  text-align: center;
  left: 0px;
  font-size: 49px;
  color: #c01e2d;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  0% {
    opacity: 1;
    color: red;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    color: red;
  }
}
.modal-wrapper {
  height: 100% !important;
}

.e-disabled {
  pointer-events: none !important;
}

.choose_athlete {
  font-size: 16px;
  color: white;
  padding: 10px;
}

.upgradeBtn {
  background: #C01E2D !important;
  color: white;
  height: 42px !important;
  font-weight: bold;
  font-size: 14px;
  width: 100%;
}

span.e-input-group.e-control-wrapper.e-ddl.e-lib.e-keyboard.e-valid-input {
  width: 150px !important;
  border-width: 1px 1px 1px 1px !important;
  border: 2px solid #d3d1d1 !important;
  background: #d3d1d1 !important;
}

button[disabled] {
  cursor: default;
  opacity: 0.4;
  pointer-events: none;
}

ion-select {
  color: black !important;
  background: #d3d1d1 !important;
  border: 2px solid #d3d1d1 !important;
  border-radius: 0px !important;
}

::ng-deep .feature-package-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.1 !important;
  --background-hover-opacity: 0.1 !important;
}
::ng-deep .feature-package-popover ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .feature-package-popover ion-item ion-radio {
  --color-checked: #be1e2d !important;
}

.comingSoonTextWeb {
  color: #c01e2d;
  text-align: center;
  animation: blinker 1s linear infinite;
  font-size: 35px;
  z-index: 100;
  position: absolute;
  padding-left: 40%;
}`, "",{"version":3,"sources":["webpack://./src/app/feature-package/feature-package.page.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA;EACE,6BAAA;EACA,iBAAA;EACA,WAAA;AAAF;;AAGA;EACE,mBAAA;EACA,eAAA;EACA,QAAA;EACA,4BAAA;EACA,yBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,uBAAA;AAAF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,+BAAA;EACA,eAAA;EACA,YAAA;AADF;;AAIA;EACE,gCAAA;AADF;;AAKE;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,4BAAA;AAFJ;;AAMA;EACE,yBAAA;EACA,uBAAA;EACA,qBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,4BAAA;EACA,yBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;;AAMA;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,QAAA;AAHF;;AAMA;EACE,wBAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,YAAA;EACA,oCAAA;AAHF;;AAMA;EACE,YAAA;EACA,oCAAA;AAHF;;AAMA;EACE,YAAA;EACA,oCAAA;AAHF;;AAMA;EACE,8BAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;AAHF;;AAMA;EACE,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;AAHF;;AAMA;EACC,+BAAA;AAHD;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;AAFF;;AAKA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,kBAAA;EAEA,cAAA;AAHF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,0BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,0BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,0BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,cAAA;AAHF;;AAMA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAHF;;AAMA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;AAHF;;AAMA;EACE,8BAAA;EACA,SAAA;EACA,6BAAA;EACA,SAAA;EACA,uBAAA;AAHF;;AAMA;EACE,8BAAA;EACA,SAAA;EACA,6BAAA;EACA,SAAA;EACA,uBAAA;AAHF;;AAMA;EACE,8BAAA;EACA,SAAA;EACA,6BAAA;EACA,SAAA;EACA,uBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;AAHF;;AAMA;EACE,8BAAA;EACA,uBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAHF;;AAMA;EACE,kCAAA;EACA,sBAAA;AAHF;;AAMA;;EAEE,uBAAA;EACA,qBAAA;AAHF;;AAMA;;EAEE,yBAAA;EACA,qBAAA;AAHF;;AAMA;EACE,2BAAA;EACA,6BAAA;AAHF;;AAMA;EACE,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,6BAAA;AAHF;;AAMA;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,6BAAA;EACA,8BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,wCAAA;EACA,aAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;;AAOA;EACE,0BAAA;EACA,4BAAA;AAJF;;AAOA;EACE,kBAAA;EACA,eAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,QAAA;AAJF;;AASE;;;EAGE,gCAAA;AANJ;AASE;EACE,YAAA;AAPJ;;AAWA;;EAEE,yBAAA;AARF;;AAWA;EACE,oCAAA;EACA,UAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE;IACE,iBAAA;EARF;EAWA;IACE,aAAA;EATF;EAYA;IACE,aAAA;EAVF;AACF;AAaA;EACE;IACE,4BAAA;IACA,mBAAA;IACA,eAAA;IACA,QAAA;IACA,4BAAA;IACA,yBAAA;EAXF;AACF;AAcA;EACE;IACE,eAAA;EAZF;EAeA;IACE,0BAAA;EAbF;EAgBA;IACE,0BAAA;EAdF;EAiBA;IACE,eAAA;EAfF;EAkBA;IACE,0BAAA;EAhBF;EAmBA;IACE,eAAA;EAjBF;EAoBA;IACE,yBAAA;EAlBF;EAqBA;IACE,UAAA;EAnBF;EAsBA;IACE,UAAA;EApBF;EAuBA;IACE,UAAA;EArBF;AACF;AAwBA;EACE;IACE,eAAA;EAtBF;EAyBA;IACE,0BAAA;EAvBF;EA0BA;IACE,yBAAA;EAxBF;EA2BA;IACE,0BAAA;EAzBF;EA4BA;IACE,cAAA;EA1BF;EA6BA;IACE,0BAAA;IACA,QAAA;EA3BF;EA8BA;IACE,cAAA;EA5BF;EA+BA;IACE,UAAA;IACA,cAAA;IACA,YAAA;EA7BF;EAgCA;IACE,UAAA;IACA,cAAA;IACA,YAAA;EA9BF;EAiCA;IACE,UAAA;IACA,cAAA;IACA,YAAA;EA/BF;EAkCA;IACE,4BAAA;IACA,mBAAA;IACA,eAAA;IACA,QAAA;IACA,4BAAA;IACA,yBAAA;EAhCF;AACF;AAmCA;EACE;IACE,wBAAA;EAjCF;EAoCA;IACE,yBAAA;EAlCF;AACF;AAqCA;EACE,oCAAA;EACA,uBAAA;AAnCF;;AAsCA;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;AAnCF;;AAsCA;EACE,YAAA;AAnCF;;AAsCA;EACE,gBAAA;AAnCF;;AAsCA;;EAEE,iCAAA;EACA,4BAAA;EACA,6BAAA;AAnCF;;AAsCA;;EAEE,oCAAA;EACA,yBAAA;EACA,WAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAnCF;;AAsCA;EACE,yBAAA;EACA,uBAAA;AAnCF;;AAsCA;EACE,uBAAA;EACA,yBAAA;AAnCF;;AAsCA;EACE,8BAAA;EACA,uBAAA;AAnCF;;AAsCA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,qCAAA;AAnCF;;AAsCA;EACE;IACE,UAAA;IACA,UAAA;EAnCF;EAsCA;IACE,UAAA;EApCF;EAuCA;IACE,UAAA;IACA,UAAA;EArCF;AACF;AAwCA;EACE,uBAAA;AAtCF;;AAyCA;EACE,+BAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;AAtCF;;AAyCA;EACE,8BAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AAtCF;;AAyCA;EACE,uBAAA;EACA,wCAAA;EACA,oCAAA;EACA,8BAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,YAAA;EACA,oBAAA;AAtCF;;AAyCA;EACE,uBAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;AAtCF;;AA0CE;EACE,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,4CAAA;EACA,0CAAA;AAvCJ;AAyCI;EACE,yBAAA;EACA,2BAAA;AAvCN;AA0CI;EACE,mCAAA;AAxCN;;AA6CA;EACE,cAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA1CF","sourcesContent":["button.joinUsParentButtonWeb.button.button-md.button-default.button-default-md:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.athelete-rookie-buy.AthleteJoinButton.button.button-md.button-default.button-default-md:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.athelete-elite-buy.AthleteJoinButton.button.button-md.button-default.button-default-md:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.athelete-pro-buy.AthleteJoinButton.button.button-md.button-default.button-default-md:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.parent-buy-btn.disable-hover.button.button-ios.button-default.button-default-ios:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.mbl-athelete-rookie-buy.disable-hover.button.button-ios.button-default.button-default-ios:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.mbl-athelete-elite-buy.disable-hover.button.button-ios.button-default.button-default-ios:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.mbl-athelete-pro-buy.disable-hover.button.button-ios.button-default.button-default-ios:hover {\n  opacity: 0.7 !important;\n}\n\nbutton.parent-buy-btn.button.button-md.button-default.button-default-md:hover {\n  opacity: 0.9 !important;\n}\n\n\n.e-grid.e-default.e-verticallines .e-headercell .e-headertext {\n  font-size: 18px;\n}\n\n.ion-md-close {\n  font-size: 24px !important;\n  position: relative;\n  top: 12px;\n  color: #ffffff;\n}\n\n.closeButtonColorActive {\n  color: #f4f7fc !important;\n}\n\n.closeButtonColorExpired {\n  color: lightgray !important;\n}\n\n.alertMessage {\n  width: 100%;\n  margin: 0 auto;\n  text-align: center;\n  top: 0px;\n  padding: 0px;\n}\n\np.alertText {\n  text-align: center !important;\n  font-size: 1.6rem;\n  width: 100%;\n}\n\nion-icon.iconCloseAlert {\n  padding-right: 10px;\n  cursor: pointer;\n  top: 0px;\n  -webkit-margin-before: 0.5em;\n  -webkit-margin-after: 0em;\n}\n\n.e-grid.e-gridhover tr[role='row']:not(.e-editedrow):hover .e-rowcell:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell) {\n  background-color: #6C6D71;\n  color: white !important;\n}\n\n\n.e-grid .e-rowcell:hover {\n  color: white !important;\n}\n\n.col {\n  border-right: 3px solid #4F524D;\n  font-size: 11px;\n  height: 75px;\n}\n\n.col-border {\n  border-bottom: 3px solid #4F524D;\n}\n\nion-navbar {\n  .col {\n    border-bottom: 0px;\n    border-right: 0px;\n    font-size: 11px;\n    height: 56px;\n    background: black !important;\n  }\n}\n\n.e-grid .e-rowcell {\n  background-color: #6C6D71;\n  color: white !important;\n  border-color: #4F524D;\n}\n\n.e-grid .e-rowcell:hover {\n  color: white !important;\n  background-color: #6C6D71;\n}\n\n.ion-md-close {\n  font-size: 24px !important;\n  position: relative;\n  top: 12px;\n  color: #ffffff;\n}\n\n.e-grid {\n  border-color: #4F524D;\n}\n\n.e-grid .e-gridheader {\n  border-bottom-color: #4F524D;\n  border-top-color: #4F524D;\n}\n\n.footer {\n  text-align: center;\n  font-size: 11px;\n  font-style: italic;\n  color: white;\n  background: #BE1E2D;\n}\n\n.e-grid .e-headercell {\n  background-color: #C01E2D;\n  color: white;\n}\n\n.large-font {\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 20px !important;\n  position: relative;\n  top: 6px;\n}\n\n.subscription {\n  height: 120px !important;\n}\n\n.subscription.subscriptionChild {\n  height: 80px !important;\n}\n\n.athelete-rookie-buy {\n  width: 120px;\n  background-color: #00c09a !important;\n}\n\n.athelete-elite-buy {\n  width: 120px;\n  background-color: #0099e1 !important;\n}\n\n.athelete-pro-buy {\n  width: 120px;\n  background-color: #f93354 !important;\n}\n\n.parent-buy-btn {\n  background: #f93354 !important;\n  width: 100%;\n  height: 43px !important;\n  float: right;\n  margin-right: 0 !important;\n  color: white;\n  font-size: 14px;\n}\n\n.featuregrid-left-margin {\n  border-left: 1px solid #4F524D;\n  text-align: center;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  border: 0px;\n  height: 75px;\n}\n\n.featuregrid-left-margin-mobile{\n  border-left: 1px solid #4F524D;\n  text-align: center;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  border: 0px;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n.featuregrid-right-margin {\n border-right: 3px solid #4F524D;\n}\n.featuregrid-top-margin {\n  border-top: 1px solid #4F524D;\n}\n\n.gridBackground {\n  background: #6C6D71;\n}\n\n.featuregrid-detail-content {\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 400;\n  top: 3px;\n  position: relative;\n}\n\n.feature-grid-smallcontent {\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.feature-grid-largecontent {\n  font-size: 36px;\n  text-align: center;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.feature-grid-header-content {\n  color: #FFFFFF;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.down-arrow {\n  width: 0;\n  height: 0;\n  border-left: 15px solid transparent;\n  border-right: 15px solid transparent;\n  content: \" \";\n  position: absolute;\n  bottom: 46px;\n  left: 42%;\n}\n\n.down-arrow-rookie {\n  border-top: 15px solid #00c09a;\n}\n\n.down-arrow-elite {\n  border-top: 15px solid #0099e1;\n}\n\n.down-arrow-pro {\n  border-top: 15px solid #f93354;\n}\n\n.onetime-activation-content {\n  font-size: 12px;\n  color: #ffffff;\n  font-weight: 400;\n}\n\n.parent-child-grid-header {\n  font-size: 14px;\n  color: #121A3E;\n  font-weight: 500;\n  padding-left: 14px;\n}\n\n.parent-child-grid-content {\n  font-size: 16px;\n  color: #31384C;\n  font-weight: 400;\n  position: relative;\n  top: 12px;\n  padding-left: 14px;\n}\n\n.parent-child-header-content {\n  font-size: 18px;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.grid-col {\n  border: none !important;\n  background: #F7F7F7;\n}\n\n.left-content {\n  margin-left: 14px;\n}\n\n.mbl-centered-content {\n  padding-left: 10px;\n  position: relative;\n  // top: 5px;\n  color: #ffffff;\n}\n\n.mbl-rookie-circle {\n  padding-left: 10px;\n  color: #00c09a;\n  font-size: 24px !important;\n}\n\n.mbl-elite-circle {\n  padding-left: 10px;\n  color: #0099e1;\n  font-size: 24px !important;\n}\n\n.mbl-pro-circle {\n  padding-left: 10px;\n  color: #f93354;\n  font-size: 24px !important;\n}\n\n.mbl-subscription {\n  padding-left: 10px;\n  color: #ffffff;\n}\n\n.mbl-large-font {\n  padding-right: 10px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  float: right;\n}\n\n.mbl-onetime-activation {\n  position: relative;\n  top: 5px;\n  left: 10px;\n  color: #ffffff;\n}\n\n.mbl-athelete-rookie-buy {\n  background: #00c09a !important;\n  top: 12px;\n  position: relative !important;\n  left: 8px;\n  height: 30px !important;\n}\n\n.mbl-athelete-elite-buy {\n  background: #0099e1 !important;\n  top: 12px;\n  position: relative !important;\n  left: 8px;\n  height: 30px !important;\n}\n\n.mbl-athelete-pro-buy {\n  background: #f93354 !important;\n  top: 12px;\n  position: relative !important;\n  left: 8px;\n  height: 30px !important;\n}\n\n.mbl-grid-col {\n  background: transparent;\n  border: none;\n  height: 30px;\n  font-size: 16px;\n  position: relative;\n  bottom: 10px;\n  color: white;\n}\n\n.mbl-parent-grid-height {\n  height: 56px !important;\n}\n\n.mbl-parent-childname-content {\n  position: relative;\n  top: 15px;\n  color: #ffffff;\n  font-weight: 400;\n  left: 10px;\n}\n\ntd.e-summarycell {\n  background: #C01E2D !important;\n  height: 50px !important;\n  color: #ffffff !important;\n}\n\n.toolbar-background-md {\n  background-color: black !important;\n}\n\n.profilemenu {\n  float: right;\n  margin-right: 15px;\n  cursor: pointer;\n  height: 40px;\n}\n\n.control-section {\n  background-color: white !important;\n  width: 100% !important;\n}\n\n.e-grid.e-default.e-verticallines .e-headercell,\n.e-grid.e-default.e-verticallines .e-detailheadercell {\n  border-width: 0 0 0 5px;\n  border-color: #4f524d;\n}\n\n.e-grid.e-verticallines .e-rowcell,\n.e-grid.e-verticallines .e-filterbarcell {\n  border-width: 0px 0 0 5px;\n  border-color: #4f524d;\n}\n\n.addathletebutton {\n  background: none !important;\n  border-right: none !important;\n}\n\nion-col.featuregrid-left-margin.mobileBorder.col {\n  border: 0px;\n  padding-top: 10px !important;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 500;\n}\n\ntable.e-table {\n  background-color: unset !important;\n}\n\n.e-gridheader.e-control.e-droppable {\n  background-color: unset !important;\n}\n\n.e-gridfooter {\n  background-color: unset !important;\n}\n\ntd.e-summarycell {\n  border-style: none !important;\n}\n\nion-col.featuregrid-left-margin.mobileHighlightColumn.col {\n  border-right: 0px;\n  border-left: 0px;\n  border-bottom: 2px solid #4F524D;\n  border-top: 2px solid #4F524D;\n  background: rgb(145, 147, 149);\n}\n\nion-grid.setBoxShadow.grid {\n  padding: 0px 5px !important;\n}\n\n.transaction-modal .modal-wrapper {\n  box-shadow: 0 28px 48px rgba(0, 0, 0, 0);\n  height: 250px;\n\n  .scroll-content {\n    overflow: hidden;\n  }\n}\n\nbutton.parent-buy-btn.button.button-md.button-default.button-default-md {\n  margin-top: 4px !important;\n  margin-right: 4px !important;\n}\n\nspan.feature-grid-smallcontent.title {\n  text-align: center;\n  font-size: 15px;\n}\n\nion-row.ActivationMessageMobile.row {\n  margin-bottom: 20px;\n  color: #ffffff;\n}\n\nion-row.HeaderMobile.row {\n  color: #ffffff;\n}\n\nspan.ActivateMessaheSizeMobile {\n  font-size: 12px;\n}\n\nion-col.featuregrid-left-margin.PackageTitle {\n  height: 50px;\n  border: 0px;\n  padding: 0 5px;\n  background: #C01E2D;\n}\n\nion-row.PackageDescriptionMobile.row {\n  height: 35px;\n}\n\nion-icon.mbl-rookie-circle.closeMobile.icon.icon-md.ion-md-close {\n  top: 5px !important;\n}\n\nion-icon.mbl-elite-circle.closeMobile.icon.icon-md.ion-md-close {\n  top: 5px !important;\n}\n\nion-icon.mbl-pro-circle.closeMobile.icon.icon-md.ion-md-close {\n  top: 5px !important;\n}\n\n#ButtonHide {\n  top: 5px;\n}\n\n#packageList {\n\n  input.e-input,\n  .e-input-group input.e-input,\n  .e-input-group.e-control-wrapper input.e-input {\n    color: rgba(255, 255, 255, 0.87);\n  }\n\n  span.e-input-group.e-control-wrapper.e-ddl.e-control.e-keyboard {\n    border: none;\n  }\n}\n\napp-home .e-grid.e-default.e-verticallines .e-headercell,\napp-home .e-grid.e-verticallines .e-rowcell {\n  border-width: 0 0 2px 3px;\n}\n\nbutton.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {\n  background-color: #C01E2D !important;\n  width: 20%;\n}\n\nion-col.featuregrid-left-margin.GridDescription.col {\n  text-align: center;\n}\n\nion-col.featuregrid-left-margin.col-border.setPadding.col {\n  padding: 9px;\n}\n\nion-col.col-border.setPadding.col {\n  padding: 9px;\n}\n\n@media only screen and (min-width : 1295px) {\n  ion-col.col-border.FeaturePackageTitle.col {\n    padding-top: 12px;\n  }\n\n  ion-col.featuregrid-left-margin.col-border.setPadding.col {\n    padding: 10px;\n  }\n\n  ion-col.col-border.setPadding.col {\n    padding: 10px;\n  }\n}\n\n@media only screen and (max-width : 1024px) and (min-width: 768px) {\n  ion-icon.iconCloseAlert {\n    font-size: 2.7rem !important;\n    padding-right: 10px;\n    cursor: pointer;\n    top: 0px;\n    -webkit-margin-before: 0.5em;\n    -webkit-margin-after: 0em;\n  }\n}\n\n@media only screen and (max-width : 768px) and (min-width: 556px) {\n  app-home .feature-grid-header-content {\n    font-size: 14px;\n  }\n\n  span.e-headertext {\n    font-size: 14px !important;\n  }\n\n  strong.large-font.web {\n    font-size: 14px !important;\n  }\n\n  app-home .featuregrid-detail-content {\n    font-size: 10px;\n  }\n\n  ion-icon.icon.icon-md.ion-md-close {\n    font-size: 20px !important;\n  }\n\n  span.onetime-activation-content.web {\n    font-size: 10px;\n  }\n\n  button.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {\n    min-width: 25% !important;\n  }\n\n  button.athelete-rookie-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {\n    width: 75%;\n  }\n\n  button.athelete-elite-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {\n    width: 75%;\n  }\n\n  button.athelete-pro-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {\n    width: 75%;\n  }\n}\n\n@media only screen and (max-width : 556px) {\n  app-home .feature-grid-header-content {\n    font-size: 11px;\n  }\n\n  span.e-headertext {\n    font-size: 11px !important;\n  }\n\n  button.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {\n    min-width: 35% !important;\n  }\n\n  strong.large-font.web {\n    font-size: 11px !important;\n  }\n\n  app-home .featuregrid-detail-content {\n    font-size: 9px;\n  }\n\n  ion-icon.icon.icon-md.ion-md-close {\n    font-size: 16px !important;\n    top: 8px;\n  }\n\n  span.onetime-activation-content.web {\n    font-size: 8px;\n  }\n\n  button.athelete-rookie-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {\n    width: 50%;\n    font-size: 5px;\n    height: 20px;\n  }\n\n  button.athelete-elite-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {\n    width: 50%;\n    font-size: 5px;\n    height: 20px;\n  }\n\n  button.athelete-pro-buy.AthleteJoinButton.button.button-md.button-default.button-default-md {\n    width: 50%;\n    font-size: 5px;\n    height: 20px;\n  }\n\n  ion-icon.iconCloseAlert {\n    font-size: 2.5rem !important;\n    padding-right: 10px;\n    cursor: pointer;\n    top: 0px;\n    -webkit-margin-before: 0.5em;\n    -webkit-margin-after: 0em;\n  }\n}\n\n@media only screen and (max-width : 450px) {\n  .subscription.subscriptionChild {\n    height: 120px !important;\n  }\n\n  button.parent-buy-btn.joinUsParentButtonWeb.button.button-md.button-default.button-default-md {\n    min-width: 40% !important;\n  }\n}\n\ntd.e-rowcell.e-selectionbackground.e-active[aria-selected=\"true\"] {\n  background-color: #919395 !important;\n  color: white !important;\n}\n\n.col-md-12.checkboxColumn {\n  text-align: center;\n  width: 100%;\n  font-size: 12px !important;\n  margin-bottom: 5px;\n}\n\np.waiverWarningText {\n  color: white;\n}\n\n.checkboxLabel {\n  margin-left: 5px;\n}\n\n#waiverCheckbox.e-checkbox-wrapper .e-frame,\n#waiverCheckbox.e-css.e-checkbox-wrapper .e-frame {\n  background-color: #000 !important;\n  border: 1px solid !important;\n  border-color: #fff !important;\n}\n\n#waiverCheckbox.e-checkbox-wrapper .e-checkbox:focus+.e-frame.e-check,\n#waiverCheckbox.e-css.e-checkbox-wrapper .e-checkbox:focus+.e-frame.e-check {\n  background-color: #e3165b !important;\n  border-color: transparent;\n  color: #fff;\n}\n\n.addOnCheckBox {\n  font-size: 12px;\n  color: #ffffff;\n  font-weight: 400;\n  display: inline-block;\n}\n\n.packageRow1 {\n  background-color: #6C6D71;\n  /*background: #aad190;*/\n}\n\n.packageRow2 {\n  /*background: #70ad48;*/\n  background-color: #919395;\n}\n\n.button-outline-ios {\n  border-color: white !important;\n  color: white !important;\n}\n\n.comingSoonText {\n  position: absolute;\n  transform: translate(20px, 130px);\n  text-align: center;\n  left: 0px;\n  font-size: 49px;\n  color: #c01e2d;\n  animation: blinker 1s linear infinite;\n}\n\n@keyframes blinker {\n  0% {\n    opacity: 1;\n    color: red;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n    color: red;\n  }\n}\n\n.modal-wrapper {\n  height: 100% !important;\n}\n\n.e-disabled {\n  pointer-events: none !important;\n}\n\n.choose_athlete {\n  font-size: 16px;\n  color: white;\n  padding: 10px;\n}\n\n.upgradeBtn {\n  background: #C01E2D !important;\n  color: white;\n  height: 42px !important;\n  font-weight: bold;\n  font-size: 14px;\n  width: 100%;\n}\n\nspan.e-input-group.e-control-wrapper.e-ddl.e-lib.e-keyboard.e-valid-input {\n  width: 150px !important;\n  border-width: 1px 1px 1px 1px !important;\n  border: 2px solid #d3d1d1 !important;\n  background: #d3d1d1 !important;\n}\n\nbutton[disabled] {\n  cursor: default;\n  opacity: .4;\n  pointer-events: none;\n}\n\nion-select {\n  color: black !important;\n  background: #d3d1d1 !important;\n  border: 2px solid #d3d1d1 !important;\n  border-radius: 0px !important;\n}\n\n::ng-deep .feature-package-popover {\n  ion-item {\n    --inner-border-width: 0;\n    --background: #ffffff;\n    background: #ffffff;\n    --color: #000000;\n    color: #000000;\n    font-size: 13px !important;\n    height: 36px;\n    --background-focused-opacity: 0.1 !important;\n    --background-hover-opacity: 0.1 !important;\n\n    ion-label {\n      color: #000000 !important;\n      --color: #000000 !important;\n    }\n\n    ion-radio {\n      --color-checked: #be1e2d !important;\n    }\n  }\n}\n\n.comingSoonTextWeb {\n  color: #c01e2d;\n  text-align: center;\n  animation: blinker 1s linear infinite;\n  font-size: 35px;\n  z-index: 100;\n  position: absolute;\n  padding-left: 40%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
